import React, { Component } from 'react';
import './MyName.css';
import './MyNameRes.css';


const MyName = () => {
    return ( 


        <>
        
        <section className='dispa'>
            <h1 className='M'>M</h1>
            <div className='name'>
                <h1 className='solo'>ariam</h1>
                <h1 className='styling solo'>arsafy</h1>
            </div>

        </section>
        
        
        
        </>
     );
}
 
export default MyName;